// :: ValidatorService
// :: This Service exports different rules to validate input fields

// :: emailValid
// :: Receives a value and tests if it is a valid email
exports.emailValid = value =>
  // eslint-disable-next-line
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value
  ) || "Email inválido";
// :: urlValid
// :: Receives a value and tests if it is a valid url
exports.urlValid = value =>
  // eslint-disable-next-line
/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
    value
  ) || "Url inválida";

// :: minLength
// :: Receives a value and tests if it meets the minimum characters
exports.minLength = min => value =>
  value.length >= min || `Mínimo de caracteres permitido: ${min}`;

// :: maxLength
// :: Receives a value and tests if it meets the maximum characters
exports.maxLength = max => value =>
  value.length <= max || `Máximo de caracteres permitido: ${max}`;

// :: required
// :: Receives a value and tests if the value is not empty
exports.required = v => !!v || "Campo requerido";
